<div *ngFor="let alert of alerts" class="{{cssClass(alert)}}">
    <a class="close" (click)="removeAlert(alert)">&times;</a>
    <span [innerHTML]="alert.message"></span>&nbsp;
    <span *ngIf="alert.details" [innerHTML]="alert.details"></span>
</div>